import { render, staticRenderFns } from "./DeviceDetail.vue?vue&type=template&id=25d735ab&scoped=true&"
import script from "./DeviceDetail.vue?vue&type=script&lang=js&"
export * from "./DeviceDetail.vue?vue&type=script&lang=js&"
import style0 from "./DeviceDetail.vue?vue&type=style&index=0&id=25d735ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d735ab",
  null
  
)

component.options.__file = "DeviceDetail.vue"
export default component.exports